function hasRid(value) {
  return value && typeof value === 'object' && value['@rid'];
}

function isFileLike(value) {
  return value && typeof value === 'object' &&
    typeof value.name === 'string' &&
    (typeof value.size === 'number' || typeof value.stream === 'function');
}

function shouldSkipField(fieldName, skipFields) {
  return skipFields.indexOf(fieldName) !== -1 ||
    /^in_/.test(fieldName) ||
    /^out_/.test(fieldName);
}

function appendFormFields(formData, form, options) {
  options = options || {};
  var skipFields = options.skipFields || [];

  Object.keys(form || {}).forEach(function (fieldName) {
    if (shouldSkipField(fieldName, skipFields)) return;
    if (typeof form[fieldName] !== 'function') return;

    var value = form[fieldName]();
    if (typeof value === 'undefined') return;

    if (value === null) {
      formData.append(fieldName, '');
    } else if (hasRid(value)) {
      formData.append(fieldName, value['@rid']);
    } else if (isFileLike(value) || typeof value !== 'object') {
      formData.append(fieldName, value);
    }
  });

  return formData;
}

module.exports = {
  appendFormFields: appendFormFields
};
